// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"SolutionLink--next-sr-only--29XgTkC","link":"SolutionLink--link--1tpvsV_","icon":"SolutionLink--icon--1LuBl3L"};